exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.markup-model .button{margin-bottom:30px\n}\n.markup-model h4{background:#d5dde2;cursor:pointer;padding:10px 15px\n}\n.markup-model h4.open{background:#97a5ad;color:#fff\n}\n.remove-rate,.remove-rate .remove-circle{position:relative\n}\n.error td{background-color:#ff9b9b!important\n}", ""]);

// exports
